module.exports = __webpack_public_path__ + "img/hearts-end-overlay.38d9d805.svg";